import React from "react";
import "./DetailPrivacyPolicy.css";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";

function DetailPrivacyPolicy() {
  return (
    <div style={{ paddingBlock: "9rem", backgroundColor: "#FFFFFF" }}>
      <Container>
        <h2 className="header">
          <strong>Privacy Policy</strong>
        </h2>

        <p>
          At <b>Boostboard,</b> we value your privacy and are committed to
          protecting your personal information. This Privacy Policy outlines how
          we collect, use, and safeguard your data when you use Boostboard, a
          digital signage platform owned and operated by{" "}
          <b>Nayatel Pvt. Ltd..</b>
        </p>
        <p>
          <strong> Information We Collect</strong>
        </p>
        <p>
          We collect the following types of information to provide and improve
          our services:
        </p>
        <ul className="privacylist">
          <li>
            <b>Account Information:</b> When you sign up for Boostboard, we
            collect personal details like your name, email address, and payment
            information.
          </li>
          <li>
            <b>Usage Data:</b> We collect information about your interactions
            with our platform, including IP addresses, device details, login
            times, and user activity, such as content uploads and schedule
            settings.
          </li>
          <li>
            <b>Content Data: </b> Any media (images, videos) or text you upload
            for display on Boostboard is stored on our secure servers.
          </li>
          <li>
            <b>Payment Information:</b> When purchasing a plan, your payment
            details (credit card, debit card, or mobile payments) are processed
            by secure third-party payment gateways (EasyPaisa, JazzCash, Visa,
            MasterCard). Boostboard does not store your payment information.
          </li>
        </ul>
        <p>
          <strong>How We Use Your Information</strong>
        </p>
        <p>We use the collected information to:</p>
        <ul>
          <li>Provide, maintain, and improve the Boostboard platform.</li>
          <li>
            Facilitate billing, manage your account, and deliver customer
            support.
          </li>
          <li>
            Monitor and analyze usage patterns to improve user experience.
          </li>
          <li>
            Communicate with you about updates, services, promotions, and
            important notices.
          </li>
          <li>
            Ensure compliance with applicable laws and prevent fraud or misuse
            of the service.
          </li>
        </ul>
        <p>
          <strong>Data Sharing and Disclosure</strong>
        </p>
        <p>
          We do not share your personal information with third parties except in
          the following situations:
        </p>
        <ul>
          <li>
            <b>With Service Providers: </b> We may share data with trusted
            third-party vendors who help operate Boostboard (e.g., payment
            processors).
          </li>
          <li>
            <b>For Legal Reasons: </b> We may disclose your information if
            required by law or in response to valid legal processes, such as a
            subpoena or government request.
          </li>
          <li>
            <b>In Business Transfers: </b> If Boostboard is involved in a
            merger, acquisition, or asset sale, your data may be transferred as
            part of the business.
          </li>
        </ul>
        <p>
          <strong> Data Security</strong>
        </p>
        <p>
          We implement industry-standard security measures, such as encryption
          and access controls, to protect your personal data. However, no online
          system is completely secure, and we cannot guarantee the absolute
          security of your information.
        </p>
        <p>
          <strong>Your Rights</strong>
        </p>
        <p>You have the right to:</p>
        <ul>
          <li>Access and review the personal information we hold about you.</li>
          <li>Request corrections or updates to your information.</li>
          <li>
            Delete your account or data (except where legally required to retain
            it).
          </li>
        </ul>
        <p>
          To exercise any of these rights, please contact us at
          <Link to="mailto:sales@nayatel.com"> sales@nayatel.com</Link>.
        </p>

        <p>
          <strong>Third-Party Links</strong>
        </p>
        <p>
          Our platform may contain links to third-party websites or services. We
          are not responsible for the privacy practices or content of these
          external sites. Please review their privacy policies before providing
          any personal information.
        </p>
        <p>
          <strong>Changes to This Privacy Policy</strong>
        </p>
        <p>
          We reserve the right to modify this Privacy Policy at any time. Any
          changes will be posted on this page, and we will notify you of
          significant updates via email or platform notifications. Your
          continued use of Boostboard constitutes acceptance of the updated
          policy.
        </p>
      </Container>
    </div>
  );
}

export default DetailPrivacyPolicy;
